import Phaser from "phaser";
import TitleScreen from "./Scenes/TitleScreen.js";
import Game from "./Scenes/Game.js";

const config = {
    width: 800,
    height: 600,
    type: Phaser.AUTO,
    scene: [TitleScreen, Game],
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 },
            debug: true,
        },
    },
};

const game = new Phaser.Game(config);
export default game;
